<div>
    <div class="main-section">
        <label class="block px-0 text-xs my-1">
            <span class="font-bold">{{ 'searchSignal.notePrefix' | translate}}: </span>
            <span>{{ 'searchSignal.noteSufix' | translate: { entity: entityType } }}</span>
        </label>
        
        @for (inputSignalField of inputSignalFields; track inputSignalField; let inputIndex = $index) {
            <div class="flex align-items-center mb-1 mt-2">
            
                <label class="flex-shrink-0 text-right px-0 font-bold text-xs w-4 leading-tight whitespace-normal">
                    {{inputSignalField.label | translate}}:
                </label>
                <div class="w-8 ml-2">
                    <input
                        #entityGenericInput
                        type="text"
                        class="form__input-field-style"
                        style="width: 100%;"
                        pInputText
                        [name]="inputSignalField.entityFieldName"
                        [(ngModel)]="inputSignalField.inputValue"
                        (ngModelChange)="inputSignalField.onInputChange()"
                        [disabled]="inputSignalField.disabledCondition && inputSignalField.disabledCondition()"
                        (keydown.enter)="search()"
                        (keydown)="inputIndex === 0 ? focusCloseButton($event, true) : null"
                        [maxlength]="inputSignalField.maxLength"
                        [autofocus]="inputIndex === 0 ? true : false"
                        [attr.id]="inputSignalField.entityFieldName"
                        [tabindex]="baseIndex + inputIndex + 1">
                    
                </div>
            </div>
        }
    </div>

    <div class="flex justify-content-center mt-4">
        <button
            class="btn-custom flex justify-content-center mx-4 align-items-center"
            [tabindex]="baseIndex + inputSignalFields.length + 1"
            (click)="search()">{{'common.search'| translate}}
        </button>
        <button
            class="btn-custom flex justify-content-center align-items-center"
            (keydown.Tab)="focusCloseButton($event)"
            [tabindex]="baseIndex + inputSignalFields.length + 2"
            (click)="reset()">{{'common.reset'| translate}}
        </button>
    </div>
</div>
